export default __webpack_public_path__ + "static/media/about-me-image.7327a60f.jpg";